import { call, put, takeLatest } from "redux-saga/effects";
import { ManagerContactDetailReportAction } from "../../../actions";
import * as types from "../../../actions/actionTypes";
import * as contactDetailReportApi from "../../../api/contactReport/detail/managerContactDetailReport";
import { GetFilterDetail } from "../../../containers/contactReports/filter/tools";

import { SetMessage } from "../../../assets/errorMessages";

export function* managerWatcherContactDetailReport() {
  yield takeLatest(types.MANAGER_GET_CONTACT_DETAIL_REVIEW_REQUEST, worker);
}

async function fetchList(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";

  return contactDetailReportApi.getList(page_number, GetFilterDetail());
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(ManagerContactDetailReportAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerContactDetailReportAction.getFailure(message));
  }
}
